import type { ComputedRef, InjectionKey } from 'vue';

export interface PaymentInfoContext {
  isCentricHub: ComputedRef<boolean>;
}

export const paymentInfoContextKey: InjectionKey<PaymentInfoContext> = Symbol('paymentInfoContext');
